export default __webpack_public_path__ + "static/media/apartment-card-saved-icon-unfilled.689ba471.svg";